// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.orgTopHeaderBox[data-v-736a0d6c] {\n  margin-top: 64px;\n}\n.red[data-v-736a0d6c] {\n  background: unset;\n}\n.grren[data-v-736a0d6c] {\n  color: #1eb521;\n}\n.select.white[data-v-736a0d6c] {\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
